module.exports = __webpack_public_path__ + "img/toplogo.d54c03cd.png";